const lang = {
  language: "English",
  lang: "en-US",
  head: {
    home: "Home",
    blog: "Blog",
    about: "About",
    login: "Log in"
  },
  about: {
    title: "About <b>Me</b>",
    content: `
    Faithfulness, honesty and principles, and always do things consistently and pursue better things;<br />
    Willing to learn, not to evade problems, willing to learn from others with an open mind;<br />
    I will devote 100% of my enthusiasm and energy to work and keep my feet on the ground;<br />
    Like team work, have a strong team spirit, work actively and enterprising.
    `
  },
  home: {
    professional: {
      title: "What <b>I Do</b> ?",
      details: {
        text: "I'm a software engineer.",
        desc:
          "I will devote 100% of my enthusiasm and energy to work and keep my feet on the ground.",
        specialty: {
          focus: {
            text: "FOCUS",
            desc: "Java, .Net, Database, Frontend."
          },
          study: {
            text: "STUDY",
            desc:
              "Study hard, avoid problems, and be willing to learn from others."
          },
          team: {
            text: "TEAM WORK",
            desc:
              "I like team work, strong team spirit and positive working attitude."
          }
        }
      }
    },
    project: {
      title: "My <b>Projects</b>"
    },
    contact: {
      title: "Contact <b>Me</b>"
    }
  },
  foot: {
    copyright: "All Rights Reserved | Design by Eraop",
    record: ""
  },
  pager: {
    prev: "Previous",
    next: "Next"
  }
};

export default lang;



// WEBPACK FOOTER //
// ./src/locale/lang/en-US.js